import {EquipmentModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: EquipmentModel = {
  id: '',
  nombre: '',
  marca: '',
  modelo: '',
  fabricacion: '',
  instalacion: '',
  capacidad: '',
  serie: '',
  proveedorId: '',
  contacto: '',
  ultimoMantenimiento: '',
  frecuenciaMantenimiento: '',
  estado: '',
  proveedorNombre: '',
  proveedorApellido: '',
  proveedorCelular: '',
  proveedorCorreo: '',
  companiaId: '',
  clienteId: '',
  site: '',
  nombreCampamento: '',
  nombreCliente: '',
  nombreCompania: '',
  siteId: '',
  campamentoId: '',
  puntoId: '',
  ...aditionalValues,
}
